import moment from 'moment';
import numeral from 'numeral';
import _ from 'lodash';

export default {
    // 默认页码
    defaultPageNum: 1,
    // 默认页尺寸
    defaultPageSize: 10,
    // 默认页可选尺寸
    defaultPageSizes: [10, 20, 50, 100],
    // 导出延时
    exportDelay: 1500,
    /**
     * 判断日期是否可选择,通常用于时间控件
     * @param date
     * @return {boolean}
     */
    disabledDate(date) {
        const current = moment(date);
        return current < moment('2018-01-01') || current > moment();
    },
    /**
     * 格式化时间YYYY-MM-DD HH:mm:ss
     * @param value
     * @param formatStr
     * @return {string|*}
     */
    formatDateTime(value, formatStr = 'YYYY-MM-DD HH:mm:ss') {
        // Null,undefined显示为空字符串
        if (value === null || value === undefined) {
            return '';
        }
        return moment(value).format(formatStr);
    },
    /**
     * 格式化银行卡号,xxxx xxxx xxxx ...
     * @param value
     * @param joinStr
     */
    formatCardNo(value, joinStr = ' ') {
        if (!value) {
            return '';
        }

        if (value.length <= 4) {
            return value;
        }

        const parts = [];
        for (let i = 0; i < value.length; i += 4) {
            parts.push(value.substring(i, i + 4));
        }

        return parts.join(joinStr);
    },
    // 枚举过滤
    filterMap(value, array) {
        let res = '';
        for (let i = 0; i < array.length; i++) {
            if (array[i].typeValue === value) {
                res = array[i].typeName;
            }
        }
        return res;
    },
    /**
     * 转换阿拉伯数字到中文大写
     * @param value
     * @return {string}
     */
    chineseCurrency(value) {
        const digits = '零壹贰叁肆伍陆柒捌玖';
        let units = '仟佰拾亿仟佰拾万仟佰拾元';
        if (!_.isNumber(value) || _.isNaN(value) || _.isNull(value) || _.isUndefined(value)) {
            return '';
        }
        if (value === 0) {
            return '零元整';
        }
        let strValue = value.toFixed(2);
        if (strValue.indexOf('.') !== -1) {
            // 去除小数点
            strValue = strValue.replace('.', '');
            units += '角分';
        }

        // 截取需要使用的unit单位
        units = units.substring(units.length - strValue.length);
        let res = '';
        for (let i = 0; i < strValue.length; i++) {
            // 遍历转化为大写的数字
            res += digits[parseInt(strValue[i], 10)] + units[i];
        }
        return res
            .replace(/零([仟佰拾角])/g, '零')
            .replace(/(零)+/g, '零')
            .replace(/零([万亿元])/g, '$1')
            .replace(/(亿)万/g, '$1')
            .replace(/^元零?|零分/g, '')
            .replace(/元$/g, '元整')
            .replace(/角$/g, '角整');
    },
    /**
     * 按照指定长度截断字符串并添加后缀
     * @param form 表单
     * @param field 待校验的字段
     * @return {Promise}
     */
    validateField(form, field) {
        return new Promise((resolve, reject) => {
            form.validateField(field, errorMessage => {
                if (!errorMessage) {
                    resolve();
                } else {
                    reject(errorMessage);
                }
            });
        });
    },
    /**
     * 枚举对象转换成数组
     * @param enumObject
     */
    enumToArray(enumObject) {
        const arr = [];

        const keys = Object.keys(enumObject);
        keys.forEach(key => {
            const prop = enumObject[key];
            arr.push(prop);
        });

        return arr;
    },
    /**
     * 枚举对象转换成map
     * @param enumObject
     */
    enumToMap(enumObject) {
        const map = {};

        const keys = Object.keys(enumObject);
        keys.forEach(key => {
            const prop = enumObject[key];
            map[prop.value] = prop.text;
        });

        return map;
    },
    /**
     * 解析导入模块
     * @param moduleFiles require返回值
     * @param excludeFiles 需要排除的文件
     * @param prefix 需要删除的前缀
     * @param suffix 需要删除的后缀
     */
    resolveRequire(moduleFiles, excludeFiles = ['index'], prefix = './', suffix = '.js') {
        const modules = {};
        moduleFiles.keys().forEach(modulePath => {
            if (excludeFiles) {
                const index = excludeFiles.findIndex(item => `${prefix}${item}${suffix}` === modulePath);
                if (index !== -1) {
                    return;
                }
            }

            let moduleName = modulePath;
            // 删除前缀和后缀生成模块名,例如'./userService.js' => 'userService'
            moduleName = modulePath.replace(prefix, '').replace(suffix, '');
            const value = moduleFiles(modulePath);
            modules[moduleName] = value.default;
        });

        return modules;
    },
    // 数字前补零
    textTransform(num, length) {
        for (var len = (num + '').length; len < length; len = num.length) {
            num = '0' + num;
        }
        return num;
    },
    // 枚举取label值
    labelToArray(value, array) {
        let res = '';
        for (let i = 0; i < array.length; i++) {
            if (array[i].value === value) {
                res = array[i].label || array[i].text;
            }
        }
        return res;
    },
    /**
     * 格式化为千分位字符串,通常用于格式化金额
     * @param value
     * @param hasPrefix
     * @return {string|*}
     */
    formatMoney(value, hasPrefix = false) {
        // 防止null,undefined显示为0.00
        if (value === null || value === undefined) {
            return '';
        }

        if (!hasPrefix) {
            return numeral(value).format('0,0.00');
        }

        return `${value > 0 ? '+' : ''}${numeral(value).format('0,0.00')}`;
    }
};
